import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type YouTubeShortsFragment = {
	__typename?: 'HMYoutubeShorts';
	category: string;
	moduleID: number;
	layout: Types.ModuleLayout;
	type: string;
	urls: Array<string>;
	translatables: { __typename?: 'ModuleTranslatables'; badge: string; title: string };
};

export const YouTubeShortsFragmentDoc = gql`
	fragment YouTubeShorts on HMYoutubeShorts {
		category
		moduleID
		translatables {
			badge
			title
		}
		layout
		type
		urls
	}
`;
